import type { TaxInput } from "@/tax/types";
import { formatCurrency } from "@/tax/format";

export type StrategyItem = { label: string; value: string };

export function buildStrategyList(input: TaxInput, baseline: TaxInput): StrategyItem[] {
  const out: StrategyItem[] = [];
  const roth = input.rothConversionAmount ?? 0;
  if (roth > 0) out.push({ label: "Roth Conversion", value: formatCurrency(roth) });
  const alt = input.alternativeInvestmentAmount ?? 0;
  if (alt > 0) out.push({ label: "Alt Investment", value: formatCurrency(alt) });

  const incomeFields: { field: keyof TaxInput; label: string }[] = [
    { field: "wages", label: "Wages" },
    { field: "spouseWages", label: "Spouse Wages" },
    { field: "interestIncome", label: "Interest" },
    { field: "ordinaryDividends", label: "Ord. Dividends" },
    { field: "qualifiedDividends", label: "Qual. Dividends" },
    { field: "iraDistributionConversion", label: "IRA Distribution" },
    { field: "grossSocialSecurity", label: "Social Security" },
    { field: "pensionSum", label: "Pension" },
    { field: "militaryRetirementPension", label: "Military Pension" },
    { field: "nonQualifiedAnnuityIncome", label: "Annuity" },
    { field: "shortTermCapitalGains", label: "ST Cap Gains" },
    { field: "longTermCapitalGains", label: "LT Cap Gains" },
    { field: "otherIncome", label: "Other Income" },
  ];
  for (const { field, label } of incomeFields) {
    const diff = ((input[field] as number) ?? 0) - ((baseline[field] as number) ?? 0);
    if (diff !== 0) {
      const sign = diff > 0 ? "+" : "-";
      out.push({ label, value: `${sign}${formatCurrency(Math.abs(diff))}` });
    }
  }
  return out;
}
